<form [formGroup]=break (ngSubmit)="submitForm(break)">
<div class="col-md-4 input-group form-group login_input">
  <label class="join_label" for="latitude" >Latitude </label>

  <input
    type="text"
    class="form-control login_txt"
    formControlName="latitude"
    id="latitude"
    required="required"
  />


</div>
<!-- <div class="col-md-4" *ngIf="myForm.get('productId').invalid && (myForm.get('productId').dirty || myForm.get('productId').touched) || (myForm.get('productId').invalid && myForm.get('productId').untouched && isSubmitted)">
  <span style="color:red;font-weight:bold"> Please provide a valid productId </span>
</div> -->

<div class="col-md-4 input-group form-group login_input">
  <label class="join_label" for="longitude" >Longitude </label>

  <input
    type="text"
    class="form-control login_txt"
    formControlName="longitude"
    id="longitude"
    required="required"
  />


</div>
<div class="row">
<fieldset>
<legend>Break</legend>
<ng-container formArrayName=breakTimes>
  <div class="row" *ngFor="let item of breakTimes?.controls; index as i" [formGroupName]="i">

  <div class="col-md-4 input-group form-group login_input">
    <label class="join_label" for="breakStartTime" >Break Start Time {{i}} </label>
    <input
      type="text"
      class="form-control login_txt"
      formControlName="breakStartTime"
      id="breakStartTime"
      required="required"
    />
  </div>

  <div class="col-md-4 input-group form-group login_input">
    <label class="join_label" for="breakEndTime" >Break End Time </label>
    <input
      type="text"
      class="form-control login_txt"
      formControlName="breakEndTime"
      id="breakEndTime"
      required="required"
    />
  </div>

  <div class="col-md-4 input-group form-group login_input">
    <label class="join_label" for="breakType" >Break Type </label>
    <input
      type="text"
      class="form-control login_txt"
      formControlName="breakType"
      id="breakType"
      required="required"
    />
  </div>

  <div class="col-md-4 input-group form-group login_input">
    <label class="join_label" for="breakHours" >Break Hours </label>
    <input
      type="text"
      class="form-control login_txt"
      formControlName="breakHours"
      id="breakHours"
      required="required"
    />
  </div>
  <div class="row">
  <fieldset>
  <legend>Facility</legend>
  <ng-container formArrayName="extraFacilities">

    <div class="row" *ngFor="let item of getExtraFacilities(i)?.controls;  index as j" [formGroupName]="j">
    <div class="col-md-4 input-group form-group login_input">
      <label class="join_label" for="facilityName" >Facility Name </label>
      <input
        type="text"
        class="form-control login_txt"
        formControlName="facilityName"
        id="facilityName"
        required="required"
      />
    </div>

    <div class="col-md-4 input-group form-group login_input">
      <label class="join_label" for="facilityType" >Facility Type </label>
      <input
        type="text"
        class="form-control login_txt"
        formControlName="facilityType"
        id="facilityType"
        required="required"
      />
    </div>

    <div class="col-md-4 input-group form-group login_input">
      <label class="join_label" for="facilityAmount" >Facility Amount </label>
      <input
        type="text"
        class="form-control login_txt"
        formControlName="facilityAmount"
        id="facilityAmount"
        required="required"
      />
    </div>
    </div>
  </ng-container>
</fieldset>
</div>

  <button (click)="addExtraTime(i)" class="btn float-right login_btn marBot20">Add Facility</button>
</div>
</ng-container>
</fieldset>
</div>
<!-- <div class="col-md-4" *ngIf="myForm.get('productName').invalid && (myForm.get('productName').dirty || myForm.get('productName').touched) || (myForm.get('productName').invalid && myForm.get('productName').untouched && isSubmitted)">
  <span style="color:red;font-weight:bold"> Please provide a valid productName </span>
</div> -->
<button (click)="addBreakTime()" class="btn float-right login_btn">Add New BreakTime</button>
<button (click)="changeLogon()">Change Logon</button>
</form>
